import { render, staticRenderFns } from "./GroupNav.vue?vue&type=template&id=af2f3b20&"
import script from "./GroupNav.vue?vue&type=script&lang=js&"
export * from "./GroupNav.vue?vue&type=script&lang=js&"
import style0 from "./GroupNav.vue?vue&type=style&index=0&id=af2f3b20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports